import React, { useEffect, useState } from "react";
import "../../Styles/Form/Responces.css";
import DataView from "./DataView";
import { TabularView } from "./TabularView";
import axios from "axios";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
const Response = () => {
  const [DataTabActive, setDataTabActive] = useState(true);
  const [TabularActive, setTabularActive] = useState(false);
  const [formData, setFormData] = useState([]);
  
  const formId = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const URl = process.env.REACT_APP_API;
    const getForm = async () => {
      try {
        const response = await axios.get(
          `${URl}/forms/${formId.formId}/individual`
        );
        setFormData(response.data);
        console.log(response.data);
      } catch (error) {
        console.log("cannot get form responses", error);
      }
    };
    getForm();
  }, [ formId.formId]);

  const dataView = `/create-form/${formId.formId}/responses/dataview`;
  const tableView = `/create-form/${formId.formId}/responses/tableview`;
  const location = useLocation().pathname;
  return (
    <>
      {/* <div className="responces-container" style={{ minHeight: "0" }}>
        <div className="responces-header">
          <div className="responces">
            <div
              className="respone_header"
              style={{
                color: location === dataView ? "#1B51BB" : "#8493B2",
                fontWeight: location === dataView ? "600" : "500",
              }}
              onClick={() => navigate(dataView)}
            >
              Data
            </div>
            <div
              className="respone_header"
              style={{
                color: location === tableView ? "#1B51BB" : "#8493B2",
                fontWeight: location === tableView ? "600" : "500",
              }}
              onClick={() => navigate(tableView)}
            >
              Table view
            </div>
          </div>
        </div>
      </div> */}
      <div
        style={{
          width: "97%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          margin: "1rem auto",
        }}
      >
        <Outlet />
      </div>
    </>
  );
};

export default Response;
